import useMutation from 'api/hooks/useMutation';
import permissions from 'api/Apollo/permissions';
import { SAMPLE_EVENTS_QUERY } from 'api/sample-events/sample-events-query-builder';
import { ALL_SAMPLE_EVENT_NAMES_QUERY } from 'api/sample-events/useQuerySampleEventNames';

import {
  mutation as updateSampleEventMutation,
  buildVariables as buildUpdateSampleEventVariables,
} from './update-sample-event-mutation-builder';

export default function useUpdateSampleEvent(options = {}) {
  const [executeMutation, response] = useMutation(updateSampleEventMutation, {
    successMsg: 'Sample event updated',
    refetchQueries: [SAMPLE_EVENTS_QUERY, ALL_SAMPLE_EVENT_NAMES_QUERY],
    ...options,
    context: { permission: permissions.writeSampleEvents },
  });

  const updateSampleEvent = async ({ id, name, description, eventJson }) => {
    const mutationResponse = await executeMutation({
      variables: {
        ...buildUpdateSampleEventVariables({
          id,
          name,
          description,
          eventJson,
        }),
      },
    });

    return mutationResponse;
  };

  return [updateSampleEvent, response];
}
